import { UntypedFormArray } from '@angular/forms';

export const swap = <T>(items: T[], a: number, b: number): T[] => {
  switch (true) {
    case a < 0:
    case b < 0:
    case a > items.length - 1:
    case b > items.length - 1:
      throw new Error('Undefined swap index');
  }
  return items.map((_, i) => {
    switch (i) {
      case a:
        return items[b];
      case b:
        return items[a];
      default:
        return items[i];
    }
  });
};

export const swapFormArray = <T extends UntypedFormArray>(formArray: T, a: number, b: number): void => {
  formArray.controls = swap(formArray.controls, a, b);
  formArray.updateValueAndValidity();
};
